import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './core/components/header/header';
import { Footer } from './core/components/footer/footer';
import { ThemeService } from './core/services/theme.service';
import { LoadingService } from './core/services/loading.service';
import { TegelModule } from '@scania/tegel-angular-17';
import { SideMenu } from './core/components/side-menu/side-menu';
import { SessionService } from './core/services/session.service';
import { Modal } from './shared/components/modal/modal';
import { MenuService } from './core/services/menu.service';
import { OperationalAreaService } from './features/operational-areas/services/operational-area.service';
import { firstValueFrom } from 'rxjs';
import { Menu } from './core/models/menu';
import { OperationalAreaStatus } from './features/operational-areas/contracts';
import { AuthService } from './core/services/auth.service';
import { ToastHost } from './shared/components/toast-host/toast-host';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, TegelModule, SideMenu, Modal, ToastHost],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly theme = inject(ThemeService);
  private readonly session = inject(SessionService);
  private readonly loading = inject(LoadingService);
  private readonly auth = inject(AuthService);

  readonly themeClass = this.theme.themeClass;
  readonly isLoading = this.loading.isLoading;

  private readonly menu = inject(MenuService);
  private readonly operationalAreaService = inject(OperationalAreaService);

  async ngOnInit(): Promise<void> {
    await this.session.initialize();

    if (!this.auth.isAuthenticated()) {
      return;
    }

    await this.loadOperationalAreas();
  }

  private async loadOperationalAreas(): Promise<void> {
    try {
      const operationalAreas = await firstValueFrom(
        this.operationalAreaService.getAll(OperationalAreaStatus.Active, true),
      );

      const areaMenus: Menu[] = operationalAreas.map((area) => ({
        id: `area-${area.areaKey}`,
        title: area.name,
        type: 'area',
        displayOrder: area.displayOrder,
        areaKey: area.areaKey,
        path: `/areas/${area.areaKey}`,
      }));

      this.menu.setOperationalAreas(areaMenus);
    } catch (error) {
      console.error('Não foi possível carregar as áreas operacionais.', error);
      this.menu.setOperationalAreas([]);
    }
  }
}
